import "../../css/FullAccordion.css";
import React, { useState, useEffect } from "react";
import { Collapse, Flex } from "antd";
import { useQuery } from "@apollo/client";
import Icon from "@ant-design/icons";
import { minusSVG, plusSVG } from "../../media/icons";
import { getFromLocalStorage, saveToLocalStorage } from "../../utils/localStorage";
import { GET_TERMS_AND_CONDITIONS, GET_FAQS, GET_PRIVACY_POLICIES } from "../../queries";
import parseCardsToAccordionPanels from '../../utils/parseCardsToAccordionPanels';

const { Panel } = Collapse;

const MinusIcon = (props) => <Icon component={minusSVG} {...props} />;
const PlusIcon = (props) => <Icon component={plusSVG} {...props} />;

const Full = ({ page, section, lang, queryType }) => {
  const fullLang = lang === 'pt' ? 'pt-br' : lang; 
  const slug = `${page}-${section}-${lang}`;
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });  

  const [activeKey, setActiveKey] = useState('generales');

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setActiveKey([hash]);

      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const yOffset = -100;
          const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);
    }
  }, []);

  const renderQuery = () => {
    const contentMap = {
      termsAndConditions: GET_TERMS_AND_CONDITIONS,
      faqs: GET_FAQS,
      privacyPolicies: GET_PRIVACY_POLICIES,
    };
    return contentMap[queryType];
  };

  const { loading, error } = useQuery(renderQuery(), {
    variables: { lang: fullLang, slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {    
      let postData;      
      if (queryType === "termsAndConditions") {
        const sortedData = fetchedData?.termsAndConditions?.nodes
          ? [...fetchedData?.termsAndConditions?.nodes].sort((a, b) => {
              if (a.slug === "generales") return -1;
              if (b.slug === "generales") return 1;
              return a.title.localeCompare(b.title);
            })
          : [];

        postData = {
          data: sortedData,
          titulo: fetchedData?.sectionsBy?.termsconditions?.tituloTac || "",
        };
      } else if (queryType === "faqs") {
        const cleanedData = fetchedData?.faqs?.nodes[0].content
        .replace(/<\/?p>/g, "")
        .replace(/<br\s*\/?>/g, "")
        .trim();
        postData = {
          data: parseCardsToAccordionPanels(cleanedData) || [],
          titulo: fetchedData?.sectionsBy?.faqs?.tituloFaqs || "",
        };
      } else if (queryType === "privacyPolicies") {        
        const sortedData = fetchedData?.privacyPolicies?.nodes
          ? [...fetchedData?.privacyPolicies?.nodes].sort((a, b) => {
              if (a.slug === "generales") return -1;
              if (b.slug === "generales") return 1;
              return a.title.localeCompare(b.title);
            }).filter(item => item.languageCode === fullLang)
          : [];
        postData = {
          data: sortedData,
          titulo: fetchedData?.sectionsBy?.privacyPolicies?.tituloPp || "",
        };
      }

      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  return (
    <>
      {sectionData && (
        <Flex className="FullAccordion">
          {sectionData.titulo && (
            <Flex className="FullAccordion-title">
              <Flex>
                <h2 className="h4-headline-500" dangerouslySetInnerHTML={{ __html: sectionData?.titulo }} />
              </Flex>
            </Flex>
          )}
          <Flex className="FullAccordion-content">
            <Collapse
              className="full-collapse"
              expandIconPosition="end"
              bordered={false}
              ghost
              accordion
              activeKey={[activeKey]}
              onChange={(keys) => setActiveKey(keys)}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <MinusIcon style={{ fontSize: "32px", color: "#0027F9" }} />
                ) : (
                  <PlusIcon style={{ fontSize: "32px", color: "#0027F9" }} />
                )
              }
            >
              {sectionData.data.map((panel, index) => {
                return (
                  <Panel header={panel.title} key={panel.slug} id={panel.slug}>
                    <div dangerouslySetInnerHTML={{ __html: panel?.content }} />
                  </Panel>
                );
              })}
            </Collapse>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default Full;
